
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event-types",
      function () {
        return require("private-next-pages/event-types/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event-types"])
      });
    }
  